<section class="card">
    <div class="card-body">
        <form class="row" #usernameForm="ngForm">
            <div class="col-12 col-lg-6">
                <h4 class="text-black"><strong>Change Username</strong></h4>
                <div class="form-group">
                    <label>Current password</label>
                    <input type="password"
                           class="form-control"
                           name="currentPassword"
                           (blur)="isCurrentPasswordTopFocus = false"
                           (focus)="isCurrentPasswordTopFocus = true"
                           [(ngModel)]="state.usernameCurrentPassword"
                           placeholder="Enter your current password"
                           id="profile-username-current-password">
                </div>
                <div class="form-group" *ngIf="state.usernameCurrentPassword || isCurrentPasswordTopFocus">
                    <label>New LLS Log-in ID</label>
                    <input type="text"
                           class="form-control"
                           name="newUsername"
                           (focus)="isNewLogoinFocus = true"
                           (blur)="isNewLogoinFocus = false"
                           [(ngModel)]="state.newUsername"
                           placeholder="Enter new LLS Log-in ID"
                           id="profile-username">
                </div>
            </div>
        </form>
        <div *ngIf="state.newUsername || isNewLogoinFocus">
            <button type="button"
                    class="btn btn-primary ui-profile-username-save-btn mr-2"
                    (click)="onUsernameSave()">Save</button>
            <button type="button"
                    class="btn btn-outline-primary"
                    (click)="clearUsername()">Clear</button>
        </div>
    </div>
</section>
<section class="card">
    <div class="card-body">
        <form class="row" #passwordForm="ngForm">
            <div class="col-12 col-lg-6">
                <h4 class="text-black"><strong>Change Password</strong></h4>
                <div class="form-group">
                    <label>Current password</label>
                    <input type="password"
                           class="form-control"
                           name="currentPassword"
                           (blur)="isCurrentPasswordBottomFocus = false"
                           (focus)="isCurrentPasswordBottomFocus = true"
                           [(ngModel)]="state.passwordCurrentPassword"
                           placeholder="Enter your current password"
                           id="profile-password-current-password">
                </div>
                <div class="form-group" *ngIf="isCurrentPasswordBottomFocus || state.passwordCurrentPassword">
                    <label>New Password</label>
                    <input [(ngModel)]="state.newPassword" class="form-control"
                           pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!-/:-@\[-`\{-~}€£¥¢])[a-zA-Z0-9!-/:-@\[-`\{-~}€£¥¢]{8,128}$"
                           maxlength="129"
                           type="password"
                           name="newPassword"
                           placeholder="Enter new password"
                           id="profile-password"
                           #newPassword="ngModel">
                    <div class="form-control-error" [hidden]="newPassword.valid || (newPassword.pristine && !passwordForm.submitted)">
                        <ul><li *ngIf="newPassword?.errors?.required">Required</li></ul>
                        <ul><li *ngIf="newPassword?.errors?.pattern">Password should be 8 or more characters with at least 1 number, 1 lowercase letter, 1 uppercase letter, and 1 special character</li></ul>
                    </div>
                </div>
                <div class="form-group" *ngIf="isCurrentPasswordBottomFocus || state.passwordCurrentPassword">
                    <label>Confirm New Password</label>
                    <input [(ngModel)]="state.newPasswordConfirm" class="form-control"
                           type="password"
                           name="newPasswordConfirm"
                           (blur)="isNewPasswordFocus = false"
                           (focus)="isNewPasswordFocus = true"
                           placeholder="Re-enter new password"
                           id="profile-password-confirm">
                </div>
            </div>
        </form>
        <div *ngIf="(state.newPasswordConfirm && state.newPassword) || isNewPasswordFocus">
            <button type="button"
                    class="btn btn-primary ui-profile-password-save-btn mr-2"
                    (click)="onPasswordSave()">Save</button>
            <button type="button"
                    class="btn btn-outline-primary"
                    (click)="clearPassword()">Clear</button>
        </div>
    </div>
</section>